export const getAdminBadge = () => {
  return (
    <span className="ml-1 inline-flex items-center">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-purple-500" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2L4 6v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V6l-8-4z"/>
        <text x="13" y="16" textAnchor="middle" className="text-xs font-bold fill-white">A</text>
      </svg>
    </span>
  );
};